/**
 * Открытия публичной ссылки — отклик автору на «поделиться».
 * Спецификация: docs/superpowers/specs/2026-10-10-share-views-design.md.
 */

/** «1 раз», «3 раза», «12 раз». */
export function timesWord(n) {
  const m10 = n % 10;
  const m100 = n % 100;
  return m10 >= 2 && m10 <= 4 && !(m100 >= 12 && m100 <= 14) ? 'раза' : 'раз';
}

const dayStart = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/**
 * «сегодня», «вчера» или «3 октября» (год — если не текущий) — по календарю того, кто смотрит: «вчера»
 * у автора в Тюмени — его вчера, а не московское. Пустое или битое время — ''.
 */
export function dayLabel(at, now = new Date()) {
  if (!at) return '';
  const d = new Date(at);
  if (Number.isNaN(d.getTime())) return '';
  const days = Math.round((dayStart(now) - dayStart(d)) / 86400000);
  if (days <= 0) return 'сегодня';
  if (days === 1) return 'вчера';
  // Прошлогоднее «3 октября» без года читалось бы как недавнее.
  const year = d.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' };
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', ...year });
}

/** Строка под ссылкой: «Открыли 3 раза, последний раз — вчера» / «Пока не открывали». */
export function viewsLabel(views, lastViewAt, now = new Date()) {
  const n = Number(views) || 0;
  if (n <= 0) return 'Пока не открывали';
  const when = dayLabel(lastViewAt, now);
  return `Открыли ${n} ${timesWord(n)}${when ? `, последний раз — ${when}` : ''}`;
}

const VIEWED_KEY = 'share-viewed:';

/**
 * Считать ли это обращение к ссылке открытием: да — один раз на вкладку.
 * Обновление страницы и возврат со входа (`?save=1`) — та же вкладка и то же
 * открытие. Отметка ставится сразу, до ответа: иначе двойной вызов эффекта
 * посчитал бы открытие дважды. Хранилище недоступно (приватное окно) —
 * считаем каждый раз: лишнее открытие лучше потерянного.
 */
export function claimShareView(token) {
  try {
    const key = VIEWED_KEY + token;
    if (window.sessionStorage.getItem(key)) return false;
    window.sessionStorage.setItem(key, '1');
    return true;
  } catch (e) {
    return true;
  }
}
